export enum CountryNameId {
  NAME_EN = 'nameEn',
  NAME_AR = 'nameAr',
  ISO2_LETTER = "iso2letter",
  ISO3_LETTER = 'iso3letter',
  COUNTRY_CODE = 'countryCode',
  CREATED_AT = 'createdAt',
}
